import { TSignupSteps } from 'types';
import { getQueryParamValue } from 'utils/common/common';

type TDefaultParams = {
  __impersonate?: string | null;
  trailingSlash?: boolean;
};

const appendImpersonation = (
  path: string,
  impersonateParam?: string | null,
): string => {
  if (impersonateParam !== null) {
    if (!impersonateParam) {
      impersonateParam = getQueryParamValue('__impersonate');
    }

    if (impersonateParam && impersonateParam !== '0') {
      return `${path}${
        path.includes('?') ? '&' : '?'
      }__impersonate=${impersonateParam}`;
    }
  }

  return path;
};

export const APPLICATION_DOCUMENTS_PATH = '/application/documents';
export const NEW_APPLICATIONS_PATH = '/application/new';

export const PATH_NAMES = {
  home: (params?: TDefaultParams) =>
    appendImpersonation('/', params?.__impersonate),

  products: (params?: TDefaultParams) =>
    appendImpersonation('/products', params?.__impersonate),

  calculator: (params?: TDefaultParams) =>
    appendImpersonation('/calculator', params?.__impersonate),

  faqs: (params?: TDefaultParams) =>
    appendImpersonation('/faqs', params?.__impersonate),

  portalTours: (params?: TDefaultParams) =>
    appendImpersonation('/portal-tours', params?.__impersonate),

  register: (
    params?: TDefaultParams & {
      introducerType?: 'broker' | 'accountant';
      inviteId?: string;
      subPath?: string;
    },
  ) => {
    const basePath = '/register';
    const subPath = params?.subPath ? `/${params.subPath}` : '';
    const searchParams = new URLSearchParams();
    if (params?.introducerType)
      searchParams.set('introducerType', params.introducerType);

    if (params?.inviteId) searchParams.set('introducer', params.inviteId);

    const queryString = searchParams.toString();
    const fullPath = `${basePath}${subPath}${queryString ? `?${queryString}` : ''}`;

    return appendImpersonation(fullPath, params?.__impersonate);
  },

  notFound: (params?: TDefaultParams) =>
    appendImpersonation('/404', params?.__impersonate),

  registrationDocuments: (params?: TDefaultParams) =>
    appendImpersonation('/registration-documents', params?.__impersonate),

  forbidden: (params?: TDefaultParams) =>
    appendImpersonation('/403', params?.__impersonate),

  whatsNew: (params?: TDefaultParams) =>
    appendImpersonation('/whats-new', params?.__impersonate),

  application: ({
    applicationId,
    trailingSlash = true,
    __impersonate,
  }: TDefaultParams & { applicationId?: string }) =>
    appendImpersonation(
      `/application${trailingSlash ? '/' : ''}?applicationId=${applicationId}`,
      __impersonate,
    ),

  applicationDocuments: ({
    applicationId,
    trailingSlash = true,
    __impersonate,
  }: TDefaultParams & { applicationId?: string }) =>
    appendImpersonation(
      `${APPLICATION_DOCUMENTS_PATH}${
        trailingSlash ? '/' : ''
      }?applicationId=${applicationId}`,
      __impersonate,
    ),

  newApplication: ({
    step,
    applicationId,
    trailingSlash,
    __impersonate,
  }: TDefaultParams & { step: TSignupSteps; applicationId?: string }) =>
    appendImpersonation(
      `/application/${step}${
        trailingSlash ? '/' : ''
      }?applicationId=${applicationId}`,
      __impersonate,
    ),

  newApplicationStep0: (params?: TDefaultParams) =>
    appendImpersonation(NEW_APPLICATIONS_PATH, params?.__impersonate),

  newApplicationStep1: ({
    applicationId,
    trailingSlash = true,
    __impersonate,
  }: TDefaultParams & { applicationId?: string }) =>
    appendImpersonation(
      `${NEW_APPLICATIONS_PATH}${
        trailingSlash ? '/' : ''
      }?applicationId=${applicationId}`,
      __impersonate,
    ),

  newApplicationProductOffers: ({
    applicationId,
    trailingSlash = true,
    __impersonate,
  }: TDefaultParams & { applicationId?: string }) =>
    appendImpersonation(
      `${NEW_APPLICATIONS_PATH}/productOffers${
        trailingSlash ? '/' : ''
      }?applicationId=${applicationId}`,
      __impersonate,
    ),

  newApplicationDocuments: ({
    applicationId,
    trailingSlash = true,
    __impersonate,
  }: TDefaultParams & { applicationId?: string }) =>
    appendImpersonation(
      `${NEW_APPLICATIONS_PATH}/documents${
        trailingSlash ? '/' : ''
      }?applicationId=${applicationId}`,
      __impersonate,
    ),

  newApplicationCheckDetails: ({
    applicationId,
    trailingSlash = true,
    __impersonate,
  }: TDefaultParams & { applicationId?: string }) =>
    appendImpersonation(
      `${NEW_APPLICATIONS_PATH}/checkDetails${
        trailingSlash ? '/' : ''
      }?applicationId=${applicationId}`,
      __impersonate,
    ),
};
